import { CustomButton } from "../../../components/global/CustomButton"
import "./orderCard.css"

export function OrderCard({ icon, title, info1, info2, info3, btnText, path }) {
    return (
        <div className="d-flex flex-column border order-card rounded-1 p-2">
            <div className="d-flex gap-3 mb-auto position-relative">
                <div className={`order-card-icon rounded-1 position-absolute ${icon}`}></div>
                <div className="card-info">
                    <div className="order-card-title mb-2">{title}</div>
                    <div>{info1}</div>
                    <div>{info2 && info2}</div>
                    <div>{info3 && info3}</div>
                </div>
            </div>
            <CustomButton
                btnLink={true}
                color="primary"
                text={btnText}
                path={path}
            />
        </div>
    )
}